export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ko",
    "resource": {
      "back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["캠페인 신청 내역으로 돌아가기"])}
    }
  })
}
